import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// utils

import { EndPoint } from '../../util/EndPoint';
// services

import { BaseService } from '../../util/BaseService';
import { RESTClientService } from '../../util/RESTClientService';
import { MensagemUtil } from '../../util/notificacao/mensagemUtil';
export class ConsultaTradicionalService extends BaseService {
/**
 * @param {?} _restCliente
 * @param {?} mensagemUtil
 */
constructor(private _restCliente: RESTClientService,
private mensagemUtil: MensagemUtil) {
    super(mensagemUtil);
  }
/**
 * @param {?} codigoEmpresa
 * @param {?} codigoInstituicao
 * @param {?} rgmAluno
 * @return {?}
 */
public getCombo(codigoEmpresa: number, codigoInstituicao: number, rgmAluno: number): Observable<any[]> {
    return this._restCliente.get(EndPoint.buscaComboTurmaTradicional(codigoEmpresa, codigoInstituicao, rgmAluno))
      .catch(error => this.handleError(error));
  }
/**
 * @param {?} codigoEmpresa
 * @param {?} codigoInstituicao
 * @param {?} codigoAluno
 * @param {?} codigoTurma
 * @return {?}
 */
public getDisciplinas(codigoEmpresa: number, codigoInstituicao: number, codigoAluno: number, codigoTurma: number): Observable<any[]> {
    return this._restCliente.get(EndPoint.buscaDisciplinaResultado(codigoEmpresa, codigoInstituicao, codigoAluno, codigoTurma))
      .catch(error => this.handleError(error));
  }
/**
 * @param {?} codigoOferta
 * @param {?} codigoInstituicao
 * @param {?} rgmAluno
 * @return {?}
 */
public getParciais(codigoOferta: number, codigoInstituicao: number, rgmAluno: number): Observable<any[]> {
    return this._restCliente
      .get(EndPoint.buscaParciais(codigoOferta, codigoInstituicao, rgmAluno))
      .catch(error => this.handleError(error));
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: RESTClientService, },
{type: MensagemUtil, },
];
}

function ConsultaTradicionalService_tsickle_Closure_declarations() {
/** @type {?} */
ConsultaTradicionalService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConsultaTradicionalService.ctorParameters;
/** @type {?} */
ConsultaTradicionalService.prototype._restCliente;
/** @type {?} */
ConsultaTradicionalService.prototype.mensagemUtil;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
